// src/actions/currentYearUIDTypes.js
export const FETCH_CURRENT_YEAR_STUDENT_UIDS_REQUEST = 'FETCH_CURRENT_YEAR_STUDENT_UIDS_REQUEST';
export const FETCH_CURRENT_YEAR_STUDENT_UIDS_SUCCESS = 'FETCH_CURRENT_YEAR_STUDENT_UIDS_SUCCESS';
export const FETCH_CURRENT_YEAR_STUDENT_UIDS_FAILURE = 'FETCH_CURRENT_YEAR_STUDENT_UIDS_FAILURE';
